
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { ReservationItemModule } from '@/store/modules/reservationItem';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { UserModule } from '@/store/modules/user';
import ElementTipTap from '@/components/ElementTipTap/index.vue';

@Component({
  name: 'BasicForm',
  components: {
    VueDaumPostcode,
    ElementTipTap,
  },
})
export default class extends Vue {
  @Prop({ default: [] }) private categoryList!: any[];

  get formData() {
    return ReservationItemModule.form;
  }

  get industry() {
    return UserModule.industry;
  }

  private formFileList: any = [];

  private imageFileList: any = [];

  private institutionList: any = [];

  private managerList: any = [];

  private inquiryList: any = [];

  private fileSizeLimit = 10;

  private apiUrl = process.env.VUE_APP_BASE_API;

  private addressFormVisible = false;

  private viewAddressForm() {
    this.addressFormVisible = true;
  }

  private SearchAddress(data: any) {
    if (data.userSelectedType === 'R') this.formData.address = data.roadAddress;
    else this.formData.address = data.jibunAddress;

    let extraDate = '';

    if (data.userSelectedType === 'R') {
      if (data.bname !== '' && /[동|로|가]$/.test(data.bname)) extraDate += data.bname;
      if (data.buildingName !== '' && data.apartment === 'Y') extraDate += (extraDate !== '' ? `, ${data.buildingName}` : data.buildingName);
      if (extraDate !== '') extraDate = `(${extraDate})`;
    } else extraDate = '';

    this.formData.address += extraDate;
    this.formData.postCode = data.zonecode;
    this.addressFormVisible = false;
  }

  private validateAddress = (rule:any, value:any, callback:any) => {
    if (!value) {
      callback(new Error('주소찾기를 눌러 주소를 등록해주세요.'));
    } else {
      callback();
    }
  };

  private rules = {
    name: [
      { required: true, message: '시설명을 입력하세요.', trigger: 'blur' },
    ],
    institutionUid: [
      { required: true, message: '시설 기관을 선택하세요.', trigger: 'blur' },
    ],
    managerUid: [
      { required: true, message: '담당자를 선택하세요.', trigger: 'blur' },
    ],
    categoryUid: [
      { required: true, message: '시설 카테고리를 선택하세요.', trigger: 'blur' },
    ],
    facilityCategoryUid: [
      { required: true, message: '시설분류를 선택하세요.', trigger: 'blur' },
    ],
    address: [
      { required: this.validateAddress, message: '주소를 입력해주세요.', trigger: 'blur' },
    ],
  };

  private handleBeforeUpload(uploadFile:File, isPhoto:boolean) {
    const fileSizeLimitByMb = this.fileSizeLimit * 1024 * 1024;
    if (isPhoto) {
      const isImageFile = uploadFile.type.split('/')[0] === 'image';
      if (!isImageFile) {
        this.$message.warning('이미지 파일만 업로드 가능합니다.');
        return false;
      }
    }
    if (uploadFile.size > fileSizeLimitByMb) {
      this.$message.warning(`파일 업로드 최대용량은 ${this.fileSizeLimit}MB입니다.`);
      return false;
    }
    return true;
  }

  private handleRemoveImageFile(file: any) {
    const index = this.formData.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > -1) this.formData.images.splice(index, 1);
  }

  private handleSuccessUploadImageFile(res: any) {
    this.formData.images.push({ fileUid: res.uid });
  }

  private handleClickLeftFile(file: any) {
    const index = this.formData.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > 0) {
      this.formData.images.splice(index - 1, 0, this.formData.images.splice(index, 1)[0]);
    }
  }

  private handleClickRightFile(file: any) {
    const index = this.formData.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index < this.formData.images.length - 1) {
      this.formData.images.splice(index + 1, 0, this.formData.images.splice(index, 1)[0]);
    }
  }

  private handleChangeEditor(value: any) {
    this.formData.detailDescription = value;
  }
}
